import React, { useState } from 'react';

const deleteUser = async (id) => {
  try {
    const response = await fetch(`${import.meta.env.VITE_REACT_APP_BACK_SPRING_USER_ENDPOINT}/users/${id}`, {
      method: 'DELETE'
    });

    if (response.ok) {
      const text = await response.text();
      console.log("response data : " + text);
      // Faire quelque chose avec les données renvoyées par le backend
    } else {
      const text = await response.text();
      console.log("error response text : " + text);
      // Gérer l'erreur et afficher un message d'erreur
    }
  } catch (ex) {
    console.log("ex : " + ex);
    // Gérer l'erreur générale et afficher un message d'erreur
  }
};

const UserDelete = () => {
  const [id, setId] = useState('');

  const handleDelete = () => {
    deleteUser(id);
  };

  const handleInputChange = (event) => {
    setId(event.target.value);
  };

  return (
    <div>
      <input type="text" value={id} onChange={handleInputChange} placeholder="Enter user ID" />
      <button onClick={handleDelete}>Delete User</button>
    </div>
  );
};

export default UserDelete;
